var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"widget-fold-button",class:{ 'is-folded': _vm.folded },attrs:{"type":"button","aria-expanded":_vm.folded ? 'false' : 'true',"title":_vm.label,"aria-label":_vm.label},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('i',{staticClass:"fas fa-chevron-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }